<template>
  <SModalCommon ref="SModalCommon" :title="config.title">
    <div class="content" v-html="config.content"></div>
  </SModalCommon>
</template>
<script>
import SModalCommon from "@/components/BuilderComponents/_components/ModalCommon.vue";

export default {
  name: "SModalTip",
  components: {
    SModalCommon
  },
  inject: {
    // 由 FiveWrap 组件传入
    $MainWrap: {
      default: () => null
    }
  },
  computed: {
  },
  data () {
    return {
      config: {
        title: '活动规则',
        content: ''
      }
    }
  },
  methods: {
    async open (options) {
      this.config = Object.assign({
        title: '活动规则',
        content: ''
      }, options)
      this.$refs.SModalCommon.open()
    },
    close () {
      this.$refs.SModalCommon.close()
    }
  }
}
</script>

<style scoped lang="scss">
.content{
  min-height: 380px;
  overflow-y: auto;
  font-size: 20px;
  padding: 10px 40px 30px;
  line-height: 30px;
}
</style>
